import { render } from "./riwayat-keluarga.vue?vue&type=template&id=58fbb5e8"
import script from "./riwayat-keluarga.vue?vue&type=script&lang=js"
export * from "./riwayat-keluarga.vue?vue&type=script&lang=js"

import "./riwayat-keluarga.vue?vue&type=style&index=0&id=58fbb5e8&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__